<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m16.59 8.29492-4.59 4.57998-4.59-4.57998-1.41 1.41 6 5.99998 6-5.99998z"
    />
  </svg>
</template>
